import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useLanguage } from '../contexts/LanguageContext';
import StoreButtons from './StoreButtons';

export default function Pricing() {
  const { translations } = useLanguage();

  return (
    <Container
      id="pricing"
      sx={{
        py: { xs: 8, sm: 14 },
      }}
    >
      <Card
        sx={{
          p: { xs: 3, sm: 6 },
          borderRadius: 6,
          overflow: 'hidden',
          background:
            'radial-gradient(circle at top left, rgba(124, 58, 237, 0.24), transparent 30%), linear-gradient(135deg, rgba(76, 29, 149, 1) 0%, rgba(79, 70, 229, 0.96) 100%)',
          color: 'common.white',
          boxShadow: '0 24px 80px rgba(76, 29, 149, 0.24)',
        }}
      >
        <Stack spacing={3.5} sx={{ maxWidth: 760 }}>
          <Box
            sx={{
              alignSelf: 'flex-start',
              px: 1.5,
              py: 0.75,
              borderRadius: 999,
              bgcolor: 'rgba(255,255,255,0.18)',
              border: '1px solid rgba(255,255,255,0.24)',
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: 'common.white',
                fontSize: '0.8rem',
                fontWeight: 800,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
              }}
            >
              {translations.pricing}
            </Typography>
          </Box>

          <Typography component="h2" variant="h3" sx={{ maxWidth: 620, lineHeight: 1.15 }}>
            {translations.pricing_section.title}
          </Typography>
          <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.84)', lineHeight: 1.7, fontWeight: 400, maxWidth: 640 }}>
            {translations.pricing_section.description}
          </Typography>

          <StoreButtons />
        </Stack>
      </Card>
    </Container>
  );
}
